// import external dependencies
import 'jquery';

// Import everything from autoload
import "./autoload/_bootstrap.js"; import "./autoload/_fontawesome.js"; import "./autoload/_hotjar.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import hasVenuesList from './flexibles/hasVenuesList';
import templateLanding from './templates/templateLanding';

import cateringCalculator from './routes/catCalc';


/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,

  //Flexible content
  hasVenuesList,

  templateLanding,

  cateringCalculator,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js